<script>
import { SET_INVALID_FORM_STATE } from "@/store/mutations.type";

export default {
  created() {
    this.setFormState(this.$v.$invalid);
  },
  watch: {
    "$v.$invalid": function(value) {
      this.setFormState(value);
    }
  },
  methods: {
    setFormState(value) {
      this.$store.commit(SET_INVALID_FORM_STATE, { isInvalid: value });
    }
  }
};
</script>
